import React from 'react'
import { AnimatedIcon } from 'shared/library/atoms/Icon'
import widgetRoutes from 'enums/routes'
import { H4, Text } from 'library/atoms/Typography'
import Button from 'library/atoms/Button'
import { useRouter } from 'next/router'
import useTranslation from 'next-translate/useTranslation'
import useBasket from 'state/useBasket'

const ModalContentAddToBasket = () => {
  const { push, query } = useRouter()
  const router = useRouter()
  const widgetSlug = query.widgetSlug as string

  const { basket } = useBasket()

  const { t } = useTranslation('chargeable')

  return (
    <>
      <AnimatedIcon name="cart" size={64} autoplay m="auto" />
      <div>
        <H4 mt={3}>{t('add-to-basket-success')}</H4>
        {!basket?.hasIncompleteBooking() ? (
          <Text paragraphMargins color="secondary">
            {t('what-would-you-like-to-do')}
          </Text>
        ) : (
          <Text paragraphMargins color="secondary">
            {t('incomplete-booking-in-basket')}
          </Text>
        )}
      </div>
      {basket?.hasIncompleteBooking() && (
        <Button
          onClick={() => router.push(widgetRoutes.BASKET.url({ widgetSlug }))}
          mt={3}
        >
          {t('go-to-basket')}
        </Button>
      )}

      {!basket?.hasIncompleteBooking() && (
        <Button
          onClick={() => router.push(widgetRoutes.CHECKOUT.url({ widgetSlug }))}
          mt={3}
        >
          {t('go-to-checkout')}
        </Button>
      )}

      <Button
        variant="secondary"
        onClick={() => push(widgetRoutes.HOME.url({ widgetSlug }))}
        mt={3}
      >
        {t('keep-shopping')}
      </Button>
    </>
  )
}

export default ModalContentAddToBasket
